import Container from "./containers/Container";

export const Login = {
    Container
}
